import { createI18n } from "vue-i18n";
import axios from "axios";

class TranslationsPlugin {
    constructor() {
        this.apiInstance = this.createAxiosInstance();
        this.defaultLanguage = "en";
        this.translations = {};
        this.languageRefs = {
            1: "en",
            3: "fr",
            4: "de",
            6: "it",
            7: "es",
            8: "ru",
        };
    }

    async init(app) {
        let sessionLanguage = this.getSessionLanguage();

        this.translations = await this.getTranslations(sessionLanguage);
        const i18n = createI18n({
            locale: sessionLanguage,
            fallbackLocale: this.defaultLanguage,
            messages: this.translations,
        });

        app.use(i18n);
    }

    createAxiosInstance() {
        
        let baseURL = "https://i18n-api.ezoic.com";

        const axiosInstance = axios.create({
            baseURL,
            withCredentials: true,
        });

        axiosInstance.interceptors.request.use(
            config => config,
            error => Promise.reject(error)
        );

        axiosInstance.interceptors.response.use(
            response => response,
            error => {
                const { config } = error;
                if (config.retries > 0) {
                    config.retries -= 1;
                    return new Promise(resolve => setTimeout(resolve, 1000))
                        .then(() => axiosInstance.request(config.url, config));
                }
                return Promise.reject(error);
            }
        );

        return axiosInstance;
    }

    getSessionLanguage() {
        let cookieRegex = document.cookie.match("(^|;)\\s*sessionLanguage\\s*=\\s*([^;]+)");
        let sessionLanguage = cookieRegex ? cookieRegex.pop() : this.defaultLanguage;
        sessionLanguage = sessionLanguage.toLowerCase();

        return Object.values(this.languageRefs).includes(sessionLanguage) ? sessionLanguage : this.defaultLanguage;
    }

    async getTranslations(language) {
        return await this.apiInstance.get(`/v1/compatibility/translations?locale=${language}&app=proteus`, { retries: 3 })
            .then(response => {
                if (response.status === 200) {
                    this.loadFromJSON(response.data);
                }
                return this.translations;
            })
            .catch((e) => {
                console.error("error getting translations: ", e);
                return this.translations; // Return default empty translations
            });
    }

    loadFromJSON(json) {
        this.defaultLanguage = json.defaultLanguage || this.defaultLanguage;
        this.translations = json.translations || {};
    }
}

export default TranslationsPlugin;
